var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutdoorIconYs({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 146,
    viewBox: "0 0 146 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_169_17050)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.701 97.7057L91.3734 29.2002L25.5508 120.45M54.7508 73.0002L40.4151 51.2873L7.30078 99.245",
    stroke: "currentColor",
    strokeWidth: 10.95,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.7008 25.5506C65.7008 31.5975 60.7993 36.5001 54.7508 36.5001C48.7033 36.5001 43.8008 31.5975 43.8008 25.5506C43.8008 19.5027 48.7033 14.6001 54.7508 14.6001C60.7993 14.6001 65.7008 19.5027 65.7008 25.5506Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7023 69.3503L80.3023 73.0003L91.2523 62.0503L108.131 76.0182L116.802 68.5088M21.9023 76.6503L29.2023 83.9503L38.6513 76.0182L51.1023 83.9503",
    stroke: "currentColor",
    strokeWidth: 5.475,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_169_17050"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 146,
    height: 146,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutdoorIconYs);
export default __webpack_public_path__ + "static/media/outdoor_icon_ys.32f5d8685fe14e5f5081d145473b4b36.svg";
export { ForwardRef as ReactComponent };